import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import file from "../../../../assets/svg/File.svg";
import category from "../../../../assets/svg/category.svg";
import $ from "jquery";
import role from "../../../../assets/svg/role.svg";
import calender from "../../../../assets/svg/calender.svg";
import infoBlack from "../../../../assets/svg/infoBlack.svg";
import versionBlack from "../../../../assets/svg/versionBlack.svg";
import obsoleteBlack from "../../../../assets/svg/obsoleteBlack.svg";
import remark from "../../../../assets/svg/remark.svg";
import { archiveTrigger, rightBarClose } from "../../../../redux/action/Action";
import {
  GET_DOCUMENT_BY_ID,
  GET_DOCUMENT_PROPERTIES,
  GET_VERSION_HISTORY,
  GET_VERSION_LOG,
  PUT_OBSOLETE,
  PUT_UNOBSOLETE,
} from "../../../../helpers/endpointService";
import axios from "axios";
import Moment from "moment";
import { PulseLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { OBSOLETE, UNOBSOLETE } from "../../../../helpers/Rightbar_action";
import { logoutFunction } from "../../../custom/commonFunction";

export default function Obsolete({ rightbarOpen, rightbarId, rightbarType }) {
  const userId = localStorage.getItem("UserId");
  const dispatch = useDispatch();
  const userRole = localStorage.getItem("Role");
  const [docProp, setDocProp] = useState();
  const [docVersion, setDocVersion] = useState();
  const [reason, setReason] = useState("");
  const [isPropertyLoader, setPropertyLoader] = useState(true);
  const [isPropertyFailed, setPropertyFailed] = useState(false);
  const [docProp1, setDocProp1] = useState({
    id: 1,
    documentName: "Levels, or decks of a building, vessel, or other structure.",
    revisedDocumentId: 11,
    documentNo: "TS-A-003",
    VersionNo: 0.5,
    category1_Name: "Content",
    category2_Name: "Code",
    author_Id: 111,
    author_Name: "Thomas Antony",
    documentDate: "01-Apr-2023",
    publishedDate: "01-Apr-2023",
    status: "Active",
    reviewDate: "01-May-2023",
    remarks:
      "An elevator (North American English) or lift (Commonwealth English) is a type of cable-assisted, hydraulic cylinder-assisted, or roller-track assisted machine that vertically transports people or freight between floors, levels, or decks of a building, vessel, or other structure.",
  });

  useEffect(() => {
    setPropertyLoader(true);
    setPropertyFailed(false);
    if (rightbarOpen) {
      $("body").addClass("scrollhide");
    }
    const fetchData = async () => {
      let propApiUrl = `${GET_DOCUMENT_BY_ID}?docId=${rightbarId}`;
      await axios
        .get(propApiUrl)
        .then((response) => {
          setPropertyLoader(false);
          if (response?.status === 200) {
            setPropertyFailed(false);
            fetchVersion();
            setDocProp(response.data);
          }
        })
        .catch((err) => {
          setPropertyLoader(false);
          setPropertyFailed(true);
          logoutFunction(err?.response?.status);
        });
    };
    fetchData();

    const fetchVersion = async () => {
      let versionApiUrl = `${GET_VERSION_LOG}?docId=${rightbarId}`;
      await axios
        .get(versionApiUrl)
        .then((response) => {
          setPropertyLoader(false);
          if (response?.status === 200) {
            setDocVersion(response.data);
          }
        })
        .catch((err) => {
          logoutFunction(err?.response?.status);
        });
    };
  }, [rightbarId]);

  const close = () => {
    dispatch(rightBarClose());
    $("body").removeClass("scrollhide");
  };

  const obsoleteFile = async () => {
    setPropertyLoader(true);

    const obsoleteDetails = {
      id: rightbarId,
      documentName: docProp.documentName,
      documentNo: docProp.documentNo,
      reason: reason,
    };

    //   if(rightbarType === OBSOLETE) {
    //     ApiUrl = `${PUT_OBSOLETE}?userId=${userId}`
    //   }
    //   else if(rightbarType === UNOBSOLETE) {
    //     ApiUrl = `${PUT_UNOBSOLETE}?userId=${userId}`
    //   }

    const ApiUrl =
      rightbarType === OBSOLETE
        ? `${PUT_OBSOLETE}?userId=${userId}`
        : rightbarType === UNOBSOLETE
        ? `${PUT_UNOBSOLETE}?userId=${userId}`
        : "";

    axios({
      method: "PUT",
      url: ApiUrl,
      data: obsoleteDetails,
    })
      .then((response) => {
        setPropertyLoader(false);
        if (response?.status === 200) {
          if (response.data === "success") {
            if (rightbarType === OBSOLETE) {
              toast.success("Obsoleted successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: "colored",
              });
            } else if (rightbarType === UNOBSOLETE) {
              toast.success("Unobsoleted successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: "colored",
              });
            }

            dispatch(archiveTrigger());
            dispatch(rightBarClose());
          } else if (response.data === "document is not published") {
            toast.warn("Document is not published", {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            });
            dispatch(rightBarClose());
          } else if (
            response.data === "renewed document cannot be unobsolete"
          ) {
            toast.warn("Renewed document cannot be unobsolete", {
              position: toast.POSITION.TOP_RIGHT,
              color: "#fff",
            });
            dispatch(rightBarClose());
          }
        }
      })
      .catch((err) => {
        logoutFunction(err?.response?.status);
      });
  };

  return (
    <>
      <div
        className={`viewbar ${rightbarOpen ? "viewbarOpen" : ""} ${
          isPropertyLoader ? "overFlowHidden" : ""
        }`}
      >
        {isPropertyLoader && (
          <div className="spinner_overlay-new">
            <div className="loader-new">
              <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
            </div>
          </div>
        )}

        {isPropertyFailed && (
          <div className="spinner_overlay-new">
            <div className="loader-new">
              <span>Loading failed</span>
            </div>
          </div>
        )}

        <ToastContainer
          limit={1}
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />

        <div className="viewMain">
          <div className="viewTitle">
            <span>{docProp?.documentNo}</span>
            {!isPropertyLoader && (
              <span className="close mt-2" onClick={close}>
                ✕
              </span>
            )}
          </div>
          {docProp && (
            <div className="inputSection">
              <div className="row">
                <div className="col-sm-6 col-12">
                  <span>
                    <img
                      style={{ position: "relative", top: "-1px" }}
                      src={infoBlack}
                      alt=""
                    />{" "}
                    Document no.
                  </span>
                  <br />
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.documentNo}
                  </span>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={file} alt="" />
                    <span> Document name</span>
                  </div>
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.documentName}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={role} alt="" />
                    <span> Author</span>
                  </div>
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.authorName}
                  </span>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={infoBlack} alt="" />
                    <span> Version</span>
                  </div>
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.version}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={category} alt="" />
                    <span> Category 1</span>
                  </div>
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.category1Name}
                  </span>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={category} alt="" />
                    <span> Category 2</span>
                  </div>
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.category2Name}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={calender} alt="" />
                    <span> Published date</span>
                  </div>
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.publishedDate
                      ? Moment(
                          new Date(Date.parse(docProp.publishedDate))
                        ).format("DD-MMM-YYYY")
                      : "-"}
                  </span>
                </div>
                <div className="col-sm-6 col-12">
                  <div className="inputTitle">
                    <img src={calender} alt="" />
                    <span> Expiry date</span>
                  </div>
                  <span style={{ fontWeight: "400", color: "#605E5C" }}>
                    {docProp.reviewDate
                      ? Moment(new Date(Date.parse(docProp.reviewDate))).format(
                          "DD-MMM-YYYY"
                        )
                      : "-"}
                  </span>
                </div>
              </div>
              {userRole === "Admin" && (
                <div className="row">
                  <div className="col-sm-6 col-12">
                    <div className="inputTitle">
                      <img src={infoBlack} alt="" />
                      <span>Status</span>
                    </div>
                    <span
                      style={{
                        fontWeight: "400",
                        color:
                          docProp.status === "Active"
                            ? "#21A366"
                            : docProp.status === "Obsolete"
                            ? "#D12232"
                            : "#FF9000",
                      }}
                    >
                      {docProp.status}
                    </span>
                  </div>
                </div>
              )}
              <div className="col-12 mt-4">
                <div className="inputTitle">
                  <img src={remark} alt="" />
                  <span>
                    {rightbarType === OBSOLETE
                      ? "Reason to obsolete"
                      : rightbarType === UNOBSOLETE
                      ? "Reason to unobsolete"
                      : ""}
                  </span>
                </div>
                <textarea
                  onChange={(e) => setReason(e.target.value)}
                  value={reason}
                  className="form-control border-radius shiptype-select mt-2"
                  style={{
                    width: "100%",
                    height: "70px",
                    fontSize: "12px",
                    maxHeight: "70px",
                  }}
                />
              </div>
              <div className="button">
                {rightbarType === OBSOLETE ? (
                  <button className="w-auto" onClick={obsoleteFile} id="edit">
                    <img
                      style={{ marginTop: "-4px", width: "14px" }}
                      src={obsoleteBlack}
                      alt=""
                    />{" "}
                    Obsolete
                  </button>
                ) : rightbarType === UNOBSOLETE ? (
                  <button className="w-auto" onClick={obsoleteFile} id="edit">
                    <img
                      style={{ marginTop: "-4px", width: "14px" }}
                      src={obsoleteBlack}
                      alt=""
                    />{" "}
                    Unobsolete
                  </button>
                ) : (
                  <></>
                )}{" "}
              </div>

              <div className="col-12 mt-3">
                <div className="inputTitle">
                  <img src={versionBlack} alt="" />
                  <span> Versions</span>
                </div>
                <div className="row mt-1">
                  <div className="col-3">
                    <div className="inputTitle">
                      <span> Version</span>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="inputTitle">
                      <span> Author</span>
                    </div>
                  </div>
                  <div className="col-5">
                    <div className="inputTitle">
                      <span style={{ whiteSpace: "nowrap" }}>
                        {" "}
                        Published date/time
                      </span>
                    </div>
                  </div>
                </div>
                {docVersion &&
                  (docVersion?.length > 0 ? (
                    docVersion?.map((list, index) => {
                      return (
                        <div className="row mt-1" key={index}>
                          <div className="col-3">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span
                                style={{ fontWeight: "400", color: "#605E5C" }}
                              >
                                {list.documentVersion}
                              </span>
                            </div>
                          </div>
                          <div className="col-4">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span
                                style={{ fontWeight: "400", color: "#605E5C" }}
                              >
                                {list.authorName}
                              </span>
                            </div>
                          </div>
                          <div className="col-5">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span style={{ fontWeight: "400" }}>
                                {list.publishedDate
                                  ? Moment(list.publishedDate).format(
                                      "DD-MMM-YYYY HH:MM A"
                                    )
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        height: "50px",
                      }}
                    >
                      <span className="noHistory">No version history</span>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
